//import "./styles.css";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Cell,
} from "recharts";

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const barColorsToUse = {
  "Page A": "#1f77b4",
  "Page B": "#ff7f0e",
  "Page C": "#2ca02c",
  "Page D": "#1f77b4",
  "Page E": "#ff7f0e",
  "Page F": "#2ca02c",
  "Page G": "#1f77b4",
};
const getIntroOfPage = (label) => {
  if (label === "Page A") {
    return "Page A is about men's clothing";
  }
  if (label === "Page B") {
    return "Page B is about women's dress";
  }
  if (label === "Page C") {
    return "Page C is about women's bag";
  }
  if (label === "Page D") {
    return "Page D is about household goods";
  }
  if (label === "Page E") {
    return "Page E is about food";
  }
  if (label === "Page F") {
    return "Page F is about baby food";
  }
  return "";
};

const barColors = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#1f77b4",
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="intro">{getIntroOfPage(label)}</p>
        <p className="desc">Anything you want can be displayed here.</p>
      </div>
    );
  }

  return null;
};

export default function App() {
  return (
    <BarChart
      width={500}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" style={{ fontSize: "12px" }} />
      <YAxis />
      <Tooltip content={<CustomTooltip />} />
      <Legend layout="horizontal" verticalAlign="top" align="right" />
      <Bar dataKey="pv" fill="green">
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={barColors[index % 20]} /> //fill={barColorsToUse[entry.name]}
        ))}
      </Bar>
    </BarChart>
  );
}
